var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 16H8V18.6875H5.3125V16ZM5.3125 10.6875H8V13.3125H5.3125V10.6875ZM5.3125 5.3125H8V8H5.3125V5.3125ZM10.6875 16H18.6875V18.6875H10.6875V16ZM10.6875 10.6875H18.6875V13.3125H10.6875V10.6875ZM10.6875 5.3125H18.6875V8H10.6875V5.3125ZM22.8125 0C23.1042 0 23.375 0.125 23.625 0.375C23.875 0.583333 24 0.854167 24 1.1875V22.8125C24 23.1042 23.875 23.375 23.625 23.625C23.375 23.875 23.1042 24 22.8125 24H1.1875C0.854167 24 0.5625 23.875 0.3125 23.625C0.104167 23.375 0 23.1042 0 22.8125V1.1875C0 0.395833 0.395833 0 1.1875 0H22.8125ZM21.3125 2.6875H2.6875V21.3125H21.3125V2.6875Z",
    fill: "#005760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListAlt);
export default __webpack_public_path__ + "static/media/list_alt.c3e792d046d6c0e91576b272d6d3c8f6.svg";
export { ForwardRef as ReactComponent };